import React, { useEffect, useState } from "react";
import Nav from "../master/NavBar";
import MocklHeader from "./MockHeader";
import { getTestSeriesList } from "../../api/TestService";
import { ToastMain, SweetAlertShow } from "../master/Master";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

const TestSerieas = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState("");
  const [search, setSearch] = useState("");
  const [sessionFilter, setSessionFilter] = useState("");

  const fetchSeriesList = async () => {
    setLoading(true);
    let addUrl = `?search=${search}`;
    if (sessionFilter) {
      addUrl += `&session_id=${sessionFilter}`;
    }

    try {
      const response = await getTestSeriesList(addUrl);
      if (response.data.status) {
        setData(response?.data?.data);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something went wrong!",
      // });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSeriesList();
  }, [search]);
  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <MocklHeader />
          <div className="layout-page">
            <Nav />

            <div className="container-fluid mt-2">
              <div className="row">
                <div className="card">
                  {/* <div className="card-body">
                    <h4>Mock test series</h4>
                  </div> */}

                  <div className="d-flex justify-content-between align-items-center mb-4">
                    {/* <h3 className="fw-bold m-0">Test Series List</h3> */}
                    <h4 className="text-primary fw-bold mb-0">
                      Mock test series
                    </h4>

                    <div className="d-flex gap-2 mt-2">
                      {/* {(permissions?.[0]?.role_id == "1" ||
                        permissions?.find(
                          (permission) =>
                            permission?.route?.frontend_url ==
                            "/test/series/add"
                        )) && ( */}
                        <button
                          className="btn btn-primary text-white d-inline-flex align-items-center overflow-hidden  transition-button"
                          data-bs-toggle="modal"
                          data-bs-target="#Addnew"
                        >
                          <span className="icon">+</span>
                          <span className="text ms-2"> Add New Test</span>
                        </button>
                      {/* )} */}
                      <Link
                        to={"/tests/view"}
                        className="btn btn-sm btn-outline-primary"
                      >
                        <i className="bi bi-arrow-left-circle me-1"></i> Back
                      </Link>
                    </div>
                  </div>

                  <div className="col-md-3 mb-2">
                    <div className="form-floating form-floating-outline">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Search series ...."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                      <label htmlFor="">Search series</label>
                    </div>
                  </div>
                </div>

                <div className="card mt-2">
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-bordered text-center align-middle">
                        <thead className="bg-primary text-white">
                          <tr>
                            <th>Sr.no</th>
                            <th>Test Series Name</th>
                            <th>Type</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(data?.data) && data.data.length > 0 ? (
                            data.data.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.title}</td>
                                <td>{item.type === "0" ? "Test" : "Exam"}</td>
                                <td>
                                  <div>
                                    {/* {(permissions?.[0]?.role_id == '1' || permissions?.find((permission) => permission?.route?.backend_url == '/test/list')) && (
                                                                <Link
                                                                  className="btn btn-outline-info btn-sm px-2 py-1"
                                                                  to={`/tests/view?id=${item.id}`}
                                                                >
                                                                  <i className="bi bi-eye"></i>
                                                                </Link>
                                                              )} */}

                                    <Link
                                      to={`/mock/test/list?id=${item.id}`}
                                      className="btn btn-outline-primary btn-sm px-2 py-1 mx-2"
                                    >
                                      <i className="bi bi-journal-text"></i>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td
                                colSpan="4"
                                className="text-center text-muted"
                              >
                                No data available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TestSerieas;
